import React, { forwardRef } from 'react'

import cn from 'classnames'

import styles from './GhostLink.module.scss'
import { GhostLinkProps } from './types'

const GhostLink: React.FC<GhostLinkProps> = forwardRef(
  (
    {
      children,
      href,
      iconElement,
      iconPosition = 'start',
      hasFullWidth,
      size = 'medium',
      ariaLabel,
      rel = 'noreferrer',
      target = '_self',
      className,
      onClick,
      testId,
      isReverse,
      title,
      ...props
    },
    ref,
  ) => (
    <a
      href={href}
      target={target}
      rel={rel}
      className={cn(
        styles.link,
        iconElement && styles.link_icon,
        !hasFullWidth && styles.link_fit,
        iconPosition === 'start' && styles.link_iconStart,
        size === 'medium' && styles.link_medium,
        size === 'large' && styles.link_large,
        isReverse && styles.link_inverted,
        className,
      )}
      aria-label={ariaLabel}
      onClick={onClick}
      data-testid={testId}
      title={title}
      ref={ref}
      {...props}
    >
      {children}
      {iconElement}
    </a>
  ),
)

export default GhostLink
